import { MousePosition, defaults as defaultControls } from "ol/control";
import { toStringHDMS } from "ol/coordinate";
import { ExtendedMap } from "../../lib/map";
import { Loader } from "../initialization/Loader";
import { parse_config } from "./Config";
export class GSAMap extends ExtendedMap {
    constructor(options) {
        super(options);
    }
    static async build(config, view) {
        const parsed = parse_config(view, config);
        GSAMap.config = parsed;
        const map = new ExtendedMap({
            target: document.getElementById('map') || undefined,
            controls: defaultControls({
                zoom: false,
            }).extend([
                new MousePosition({
                    coordinateFormat: toStringHDMS,
                    projection: 'EPSG:4326',
                    target: document.getElementById('mouse-position') || undefined,
                    className: 'custom-mouse-position'
                })
            ]),
            strategy: new Loader(parsed)
        });
        return await map.loaded();
    }
}
